var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.media)+"\n  "),_c('br'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.fetchData()}}},[_vm._v("Neu Laden")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }